import(/* webpackMode: "eager", webpackExports: ["Split"] */ "/app/src/screens/Split/ui/Split.tsx");
